import React from 'react';


import images from '../../assets';
import Store from 'store';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import apiClient from '../../_utils/axios';
import { countBasketItem } from '../../_actions/userAction';
import { useTranslation } from 'react-i18next';

const preminumimg = {
  width: 50,
  height: 50,
  cursor: 'pointer',
  display: 'inline-block',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
};

const hoverStyle = {
  transform: 'scale(1.1)',
  boxShadow: '0 10px 20px rgba(0, 0, 0, 0.2)'
};

export  const CartBtn = ({ preminumimg, remove, productId, ShowBasketModal, is_in_cart, setCartInOut}) => {
  const {t} = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const onBasket = async () => {

    if (!Store.get('accessToken')) {
      let err = t('sign_in_to_your_account');

      alert(err);
      return history.push('/auth');
    }
    
    const res = await apiClient.post(`/web/cart/${productId}`);

    if (res && res.status === 200) {
      ShowBasketModal();
      const result = await countBasketItem();
      if(result.status === 200){
        dispatch({
          type : 'set',
          payload : {
            totalCartCount: result.data.totalCount,
          }
        })
      }
      setCartInOut(productId);
    }
  };
  const takeOutBasket = async () => {

    if (!Store.get('accessToken')) {
      let err = t('sign_in_to_your_account');
      alert(err);
      return history.push('/auth');
    }

    const res = await apiClient.delete(`/web/cart/product_id/${productId}`);

    if (res && res.status === 200) {
      const result = await countBasketItem();
      if(result.status === 200){
        dispatch({
          type : 'set',
          payload : {
            totalCartCount: result.data.totalCount,
          }
        })
      }
      setCartInOut(productId);
    }
  };
  const [hovered, setHovered] = React.useState(false);

  const handleMouseEnter = () => setHovered(true);
  const handleMouseLeave = () => setHovered(false);

  // return (
  //   <>
  //     {is_in_cart ? (
  //       <div style={{ ...preminumimg, marginRight: 10 }} onClick={takeOutBasket}>
  //         <img
  //           alt=""
  //           src={remove ? images.icon_basket_rmv_in : images.icon_basket_in}
  //           style={hovered ? hoverStyle : {}}
  //           onMouseEnter={handleMouseEnter}
  //           onMouseLeave={handleMouseLeave}
  //         />
  //       </div>
  //     ) : (
  //       <div style={{ ...preminumimg, marginRight: 10 }} onClick={onBasket}>
  //         <img
  //           alt=""
  //           src={remove ? images.icon_basket_rmv : images.icon_basket}
  //           style={hovered ? hoverStyle : {}}
  //           onMouseEnter={handleMouseEnter}
  //           onMouseLeave={handleMouseLeave}
  //         />
  //       </div>
  //     )}
  //   </>
  // );
  return (
    <>
      <div
        style={{ ...preminumimg, marginRight: 10 }}
        onClick={is_in_cart ? takeOutBasket : onBasket}
      >
        <img
          alt=""
          src={
            is_in_cart
              ? (remove ? images.icon_basket_rmv_in : images.icon_basket_in)
              : (remove ? images.icon_basket_rmv : images.icon_basket)
          }
          style={hovered ? hoverStyle : {}}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
      </div>
    </>
  );  
};

export default CartBtn;
